import { render } from "./BorderButton.vue?vue&type=template&id=2b283cf5"
import script from "./BorderButton.vue?vue&type=script&lang=js"
export * from "./BorderButton.vue?vue&type=script&lang=js"

import "./BorderButton.vue?vue&type=style&index=0&id=2b283cf5&lang=scss"

import exportComponent from "C:\\Users\\MAX\\Documents\\Repositorios\\gem_tpv_pwa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__